<template>
  <div class="d-flex">
    <div class="border-right" style="width: 70%">
      <div  class="mt-3 mb-3 font-16 font-weight-600 d-flex align-items-center">
        <span class="text-dark" style="margin-left: 20px">Chi tiết đơn hàng:</span>
        <span class="ms-2 text-primary">{{ order.code }}</span>
        <div @click="copy(order.code)" role="button">
          <IconV2
            class="ms-2"
            name="v2-copy"/>
        </div>
        <el-badge class="fw-semibold font-size-11 ms-2 px-1"
                  :style="{color: app.colorOrder[order.state], 'background-color': setTransparencyHex(app.colorOrder[order.state],0.2),'border-color': setTransparencyHex(app.colorOrder[order.state],0.2),'border-radius':'4px',}">
          {{ order.state }}
        </el-badge>
      </div>
      <div class="border-top">
        <el-table :data="order.swItems" class="custom-order-detail" height="280">
          <el-table-column label="Thông tin sản phẩm">
            <template slot-scope="scope">
              <div class="d-flex align-items-center">
                <div style="height: 56px">
                  <el-image style="height: 56px; width: 56px; border-radius: 4px;border: 1px solid #EAECF2;" :src="scope.row.image"></el-image>
                </div>
                <div class="flex-grow-1 px-12">
                  <span class="text-ellipsis-2-line text-primary">{{ scope.row.name }}</span>
                  <div class="text-ellipsis-1-line">{{ scope.row.productCode }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Số lượng" width="110" header-align="center" align="center">
            <template slot-scope="scope">
              {{ scope.row.amount }}
            </template>
          </el-table-column>
          <el-table-column label="Đơn giá" width="110" header-align="center" align="center">
            <template slot-scope="scope">
              {{ order.price_policy === 'retail_price' ? separateNumberByThousand(scope.row.price) : separateNumberByThousand(scope.row.wholesale_price) }} đ
            </template>
          </el-table-column>
          <el-table-column label="Thành tiền" width="130" header-align="center" align="center">
            <template slot-scope="scope">
              {{ order.price_policy === 'retail_price' ? separateNumberByThousand(scope.row.price*scope.row.amount) : separateNumberByThousand(scope.row.wholesale_price*scope.row.amount) }} đ
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="mt-12px border-top border-bottom" style="height: 8px;background-color: rgba(234, 236, 242, 0.3)" ></div>
      <div class="d-flex" style="height: 250px">
        <div class="pt-16 pb-16 pl-16 w-50 border-right">
          <div style="padding:0 0 8px 4px">
            <div class="font-weight-600 mb-2">Lịch sử trạng thái đơn hàng:</div>
            <div style="min-height: 180px; max-height: 180px; overflow: auto;padding-right: 16px">
              <div v-for="(h, i) in order.historyState" :key="i" style="padding-top: 6px; padding-bottom: 6px">
                <div class="d-flex">
                  <div style="width: 11px!important;">
                    <div style="border-radius: 50%; background-color: #327AE7;height: 8px;width: 8px;outline: 2px solid #D4E4FF;margin-top: 7px;margin-left: 2px"></div>
                  </div>
                  <div class="ms-2">
                    <div class="d-flex align-items-center">
                      <div class="opct-70 no-wrap">{{ convertTimeOrderDetail(h.updatedAt) }}</div>
                      <el-badge class="fw-semibold font-size-11 ms-2 px-1 text-ellipsis-1-line"
                                :style="{color: app.colorOrder[h.state], 'background-color': setTransparencyHex(app.colorOrder[h.state],0.2),'border-color': setTransparencyHex(app.colorOrder[h.state],0.2),'border-radius':'4px',}">
                        {{ h.state }}
                      </el-badge>
                    </div>
                    <div style="word-break: break-word">{{ h.note }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pt-16 pb-16 pl-16 w-50">
          <div class="pb-2">
            <div class="font-weight-600 mb-2">Lịch sử vận chuyển:</div>
            <div v-if="order.delivery && order.delivery.history" style="min-height: 180px; max-height: 180px; overflow: auto; padding-right: 16px">
              <div v-for="(h, i) in order.delivery.history" :key="i" style="padding-top: 6px; padding-bottom: 6px">
                <div class="d-flex">
                  <div style="width: 11px!important;">
                    <div style="border-radius: 50%; background-color: #327AE7;height: 8px;width: 8px;outline: 2px solid #D4E4FF;margin-top: 7px;margin-left: 2px"></div>
                  </div>
                  <div class="ms-2">
                    <div class="opct-70 no-wrap">{{ convertTimeOrderDetail(h.updatedAt) }}</div>
                    <div style="word-break: break-word">{{ h.note }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="padding: 12px 20px 24px 20px;width: 30%">
      <div class="d-flex justify-content-lg-end" @click="$emit('close')">
        <IconV2 class="float-right" role="button" name="v2-close" />
      </div>
      <div class="mt-2 d-flex justify-content-lg-between">
        <div class="font-weight-600 text-gray opct-70">Tên khách hàng</div>
        <div class="text-label">{{ order.customer.name }}</div>
      </div>
      <div class="mt-2 d-flex justify-content-lg-between">
        <div class="font-weight-600 text-gray opct-70">Số điện thoại</div>
        <div class="text-label">{{ order.customer.phone }}</div>
      </div>
      <div class="mt-2 d-flex justify-content-lg-between">
        <div class="font-weight-600 text-gray opct-70" style="width: 150px">Địa chỉ</div>
        <div class="text-label text-ellipsis-3-line" style="text-align: right; word-break: break-word;">{{ [order.customer.address,app.localData.wards[order.customer.wardId].name || '',app.localData.districts[order.customer.districtId].name || '',app.localData.provinces[order.customer.provinceId].name || ''].join(', ') }}</div>
      </div>
      <div class="mt-2 d-flex justify-content-lg-between">
        <div class="font-weight-600 text-gray opct-70">Ghi chú</div>
        <div class="text-label">{{ order.noteCustomer ? order.noteCustomer :  '--' }}</div>
      </div>
      <div class="mt-2 d-flex justify-content-lg-between border-bottom" style="padding-bottom: 12px">
        <div class="font-weight-600 text-gray opct-70">Ngày tạo</div>
        <div class="text-grey700">{{ convertTimeOrderDetail(order.createdAt) }}</div>
      </div>
      <div class="mt-2 d-flex justify-content-lg-between" >
        <div class="font-weight-600 text-gray opct-70">Đơn vị vận chuyển</div>
        <div class="text-label">{{ order.delivery.logistic }}</div>
      </div>
      <div class="mt-2 d-flex justify-content-lg-between" >
        <div class="font-weight-600 text-gray opct-70">Phí vận chuyển</div>
        <div class="text-label">{{ separateNumberByThousand(order.shippingFee) }} đ</div>
      </div>
      <div class="mt-2 d-flex justify-content-lg-between" >
        <div class="font-weight-600 text-gray opct-70">Mã vận chuyển</div>
        <div class="text-label">{{ order.delivery && order.delivery.id ? order.delivery.id : "--" }}</div>
      </div>
      <div class="mt-2 d-flex justify-content-lg-between" >
        <div class="font-weight-600 text-gray opct-70">Bên trả phí</div>
        <div class="text-label">{{ order.payment_type_id === 1 ? 'Người bán' : 'Người mua'}}</div>
      </div>
      <div class="mt-2 d-flex justify-content-lg-between border-bottom" style="padding-bottom: 12px" >
        <div class="font-weight-600 text-gray opct-70">Ghi chú</div>
        <div class="text-label">{{ order.noteShipper ? order.noteShipper : '--'}}</div>
      </div>
      <div class="mt-2 d-flex justify-content-lg-between" >
        <div class="font-weight-600 text-gray opct-70">Chính sách giá</div>
        <div class="text-label">{{ order.price_policy === "retail_price" ? 'Bán lẻ' : 'Bán buôn'}}</div>
      </div>
      <div class="mt-2 d-flex justify-content-lg-between" >
        <div class="font-weight-600 text-gray opct-70">Tổng tiền hàng</div>
        <div class="text-label">{{ separateNumberByThousand(totalNoFee) }} đ</div>
      </div>
      <div class="mt-2 d-flex justify-content-lg-between" >
        <div class="font-weight-600 text-gray opct-70">Chiết khấu</div>
        <div class="text-label">{{ order.typeDiscount === 'VND' ? `${separateNumberByThousand(order.discount)} đ` : `${order.discount} %`  }} </div>
      </div>
      <div class="mt-2 d-flex justify-content-lg-between" >
        <div class="font-weight-600 text-gray opct-70">Khách trả trước</div>
        <div class="text-label">{{ separateNumberByThousand(order.paid)}} đ</div>
      </div>
      <div class="mt-2 d-flex justify-content-lg-between" >
        <div class="font-weight-600 text-gray opct-70">Phụ thu</div>
        <div class="text-label">{{ separateNumberByThousand(order.otherFee)}} đ</div>
      </div>
      <div class="mt-2 d-flex justify-content-lg-between" >
        <div class="font-weight-600 text-gray opct-70">Doanh thu ước tính</div>
        <div class=" text-primary">{{ order.delivery.logistic === "TVC" && order.payment_type_id === 1 ? separateNumberByThousand(order.totalPrice-(Number(order.shippingFee) || 0)) : separateNumberByThousand(order.totalPrice) }} đ</div>
      </div>
      <div class="mt-2 d-flex justify-content-lg-between" >
        <div class="font-weight-600 text-danger">Tiền COD</div>
        <div class="text-label">{{ separateNumberByThousand(order.pickMoney)}} đ</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderDetailV2",
  props: ["order"],
  computed:{
    totalNoFee(){
      let totalCost = this.order.swItems.reduce((agg, val) => {
        if(this.order.price_policy == 'retail_price'){
          agg += parseInt(val.price)*parseInt(val.amount || 0)
        } else{
          if(!val.wholesale_price) val.wholesale_price = 0
          agg += parseInt(val.wholesale_price)*parseInt(val.amount || 0)
        }
        return agg
      }, 0);
      return totalCost
    },
  },
  methods:{
    copy(code) {
      const el = document.createElement("textarea");
      el.value = code;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.alert("success", "Đã sao chép");
    },
    separateNumberByThousand(number) {
      if (!number)
        number = 0;
      return number.toString().replace(/[^0-9.]/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
  }
};
</script>

<style scoped>
.font-weight-600{
  font-weight: 600;
}
.text-ellipsis-2-line {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  max-height: 42px;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: normal;
}
::-webkit-scrollbar {
  width: 3px;
  height: 3px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 8px;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(196, 191, 191);
  border-radius: 8px;

}
.text-ellipsis-1-line {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  max-height: 21px;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.text-ellipsis-3-line {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  max-height:63px;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: normal;
}
.opct-70{
  color: rgba(96,98,102, 0.7);
}
.text-label{
  color: #0e0e0e;
}
.no-wrap{
  white-space: nowrap;
}
</style>